import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e65f60c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-content" }
const _hoisted_2 = { class: "option-group" }
const _hoisted_3 = { class: "option-label" }

import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import type { BasicSubSettings } from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'notify-settings',
  props: {
  modelValue: {
    type: Object as PropType<BasicSubSettings>,
    required: true
  },
  readonly: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emits = __emit

const strategy = computed({
  get: () => props.modelValue,
  set: (val) => emits('update:modelValue', val)
})

function handleChange() {
  emits('change')
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.notifyBubbleTitle')), 1),
      (_unref(IS_JP_ONLY_BUILD))
        ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 0,
            class: "option-row",
            modelValue: strategy.value.allow_notify_spreadinfo,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((strategy.value.allow_notify_spreadinfo) = $event)),
            modelModifiers: { number: true },
            "true-label": 1,
            "false-label": 0,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.notifySpreadInfo')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: strategy.value.allow_notify_hackattack,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((strategy.value.allow_notify_hackattack) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.notifyHackAttack')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      (!_unref(IS_JP_ONLY_BUILD))
        ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 1,
            class: "option-row",
            modelValue: strategy.value.allow_notify_wormattack,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((strategy.value.allow_notify_wormattack) = $event)),
            modelModifiers: { number: true },
            "true-label": 1,
            "false-label": 0,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.notifyWormAttack')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]))
        : _createCommentVNode("", true),
      (!_unref(IS_JP_ONLY_BUILD))
        ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 2,
            class: "option-row",
            modelValue: strategy.value.allow_notify_leak,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((strategy.value.allow_notify_leak) = $event)),
            modelModifiers: { number: true },
            "true-label": 1,
            "false-label": 0,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.notifyHighVulnBubble')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})